import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["listen"];
import React from 'react';
import { isServerEnvironment } from '../../common/utils';
import { useRouterStore } from '../router-store';
export const RouterSubscriber = _ref => {
  let {
    children
  } = _ref;
  const [state, _ref2] = useRouterStore();

  const {
    listen
  } = _ref2,
        actions = _objectWithoutPropertiesLoose(_ref2, _excluded);

  if (!state.unlisten && !isServerEnvironment()) {
    listen();
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, children(state, actions));
};